import { Text } from '@blueprintjs/core';
import PropTypes from 'prop-types';

const BOSNoWrapText = ({ children, maxWidth }) => {
  return (
    <div style={{ maxWidth: maxWidth || '100%', display: 'inline-flex' }}>
      <Text ellipsize style={{}}>
        {children}
      </Text>
    </div>
  );
};

BOSNoWrapText.propTypes = {
  children: PropTypes.any,
  maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default BOSNoWrapText;
